module.exports = __webpack_public_path__ + "static/img/header-1.fdd4b286.png";